<article class="dt-l-article">
  <header class="dt-l-article__header">
    <h1 class="dt-l-article__header__title" id="dialog-title" tabindex="-1" #dialogTitle>{{
      'PAGE_HEADING' | translate
    }}</h1>
    <div class="dt-l-article__header__description">{{ 'PAGE_SUBHEADING' | translate }}</div>
  </header>

  <div class="dt-l-article__content">
    <section class="dt-l-article__section">
      @if (survey) {
        <dt-survey-core
          [className]="'dt-c-public-survey'"
          [surveyData]="survey"
          [isDialog]="false"
          (formSubmit)="onSubmit($event)"></dt-survey-core>
      } @else {
        <dt-blankslate [options]="blankslateOptions"></dt-blankslate>
      }
    </section>
  </div>
</article>
